import { apiFetch } from '@ami/react/core';
import { TeamFilter } from './teamFilter';

const _baseEndPoint = 'teams';

export class Team {
  constructor(item) {
    if (item) {
      this.id = item.id;
      this.name = item.name;
      this.amiUserIds = item.amiUserIds;
      this.isRetired = item.isRetired;
      return;
    }
    this.id = null;
    this.name = '';
    this.amiUserIds = [];
    this.isRetired = false;
  }

  static async search(filter = new TeamFilter(), page) {
    filter.setPaginationParameters(page);
    const result = await apiFetch(`${_baseEndPoint}?${filter.toQueryString()}`);
    return result.map((x) => new Team(x));
  }

  static getTeamOptions() {
    return apiFetch(_baseEndPoint).then((entities) =>
      Promise.resolve(
        entities.map((x) => ({
          id: x.id,
          label: x.name,
        }))
      )
    );
  }

  static async getById(id) {
    const entity = await apiFetch(`${_baseEndPoint}/${id}`);
    return new Team(entity);
  }

  static retire(id) {
    return apiFetch(`${_baseEndPoint}/${id}`, 'DELETE');
  }

  static create(item) {
    return apiFetch(_baseEndPoint, 'POST', item);
  }

  update() {
    return apiFetch(`${_baseEndPoint}/${this.id}`, 'PUT', this);
  }

  delete() {
    return apiFetch(`${_baseEndPoint}/${this.id}`, 'DELETE', this);
  }
}
